import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DetailProperty, ValueSelection } from '../objects/DetailObject';
import { DetailService } from '../services/detail.service';
import { MatTreeNestedDataSource } from '@angular/material';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MyTreeNode } from '../objects/TreeviewObject';

@Component({
  selector: 'app-hierarchy',
  templateUrl: './hierarchy.component.html',
  styleUrls: ['./hierarchy.component.css']
})
export class HierarchyComponent implements OnInit {

  @Input() componentId: string;
  @Input() treeDataSource: MatTreeNestedDataSource<MyTreeNode>;
  @Input() treeControl: NestedTreeControl<MyTreeNode>;
  @Input() hasChildren: any;
  @Input() hasCheckbox: boolean = false;
  @Input() selectItem: string;
  @Input() fixedHeight: boolean = false;
  @Input() propertyName: string;
  @Input() showHierarchy : boolean;
  @Input() propertyDisplay: string;
  @Input() singleSelection: boolean;
  @Input() hasSearch: boolean;
  @Output() checkedItem = new EventEmitter<DetailProperty>();
  @Output() expandNode = new EventEmitter<any>();
  @Output() onCloseHierarchy = new EventEmitter<boolean>();
  @Output() searchHierarchy = new EventEmitter<string>();

  constructor(private detailService: DetailService) { }

  ngOnInit() {
  }

  closeHierarchy(){
    // this.detailProperty.PropertyShowHierarchy = false;
    this.onCloseHierarchy.emit(false);
  }

  onCheckedNode($event: any){
    this.checkedItem.emit($event);
  }

  onExpandNode($event){
    this.expandNode.emit($event)
  }

  onSearchChanged(keyword: string){
    this.searchHierarchy.emit(keyword);
  }

}